import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { BlacklistAddressInput } from '@/models/blacklistAddress';

export const updateBlacklistAddress = async ({ id, data }: { id: number; data: BlacklistAddressInput }) => {
  const response = await mutationExecute({
    variables: {
      data,
      id,
    },
    mutation: graphql(`
      mutation UpdateAddress($data: AddressInputType!, $id: Float!) {
        updateAddress(data: $data, id: $id) {
          id
          name
          phoneNumber
          streetAddress
          streetAddress2
          city
          state
          country
          zip
          latitude
          longitude
          radius
          reason
          blackListedAt
          flaggedAt
          createdAt
          updatedAt
        }
      }
    `),
  });

  return response.data?.updateAddress!;
};
